export default __webpack_public_path__ + "static/media/8t.d14d6e21.jpg";